import script from "./WhatsappActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsappActivation.vue?vue&type=script&setup=true&lang=js"

import "./WhatsappActivation.vue?vue&type=style&index=0&id=5c38e8f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c38e8f3"]])

export default __exports__